// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"_1_A56","ContentContainer":"_30KIy","Description":"Iw5Gz","ImageContainer":"wrfgq","Image":"_3MxI8"};